import {useCustomer} from "../../../layouts/SelfcareLayout.tsx";
import {ProductInstance} from "../../../util/types.ts";
import OptIn from "./OptIn.tsx"
import Wifi, {WifiHeader} from "./Wifi.tsx";
import InternetStatus from "./InternetStatus.tsx";

export default function NetworkOverview({product_instances}: { product_instances: ProductInstance[] }) {
    const {customer} = useCustomer()
    const hasMultipleProducts = customer.product_instances.length > 0;

    return <>
        <div className={'selfcare-page-summary'}>
            <h1 className={'heading heading--big'}>Mit netværk</h1>
        </div>
        <div className={'selfcare-network-overview'}>
            {product_instances
                .map((product_instance, i) => (
                    <ProductOnlineStatus
                        key={i}
                        customer_id={customer.customer_id}
                        product_instance={product_instance}
                        has_multiple_products={hasMultipleProducts}
                    />
                ))
            }
        </div>
    </>
}

function ProductOnlineStatus({customer_id, product_instance, has_multiple_products}: {
    customer_id: string;
    product_instance: ProductInstance;
    has_multiple_products: boolean;
}) {
    return (
        <div className={'selfcare-network-overview-item'}>
            {has_multiple_products && (
                <h2 className={'heading heading--montserrat'}>
                    {product_instance.product.product_display_name}
                </h2>
            )}

            <InternetStatus customer_id={customer_id} product_instance={product_instance}/>

            <OptIn customer_id={customer_id} type={'wifi'} method={'sms'} header={<WifiHeader/>}>
                <Wifi customer_id={customer_id} product_instance={product_instance}/>
            </OptIn>
        </div>
    )
}
